/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Career'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019.2020  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeCareer from '../../../components/career/Home.vue'; // 'Home-Career' ..

export const routescareer = [
    { path: '', component: HomeCareer },
];



// WEBPACK FOOTER //
// ./src/routes/modules/career/routes.js